module.exports = __webpack_public_path__ + "static/img/ourImg.7ceae43.png";


//////////////////
// WEBPACK FOOTER
// ./static/ourImg.png
// module id = iqlM
// module chunks = 1